export const handlers = {};


function registerNotificationHandler(type, handler) {
	console.log('registering notification handler', type);
	handlers[type] = handler;
}

function runNotificationHandler(type, message, setChild) {
	if(typeof handlers[type] === 'function') {
		return handlers[type](message, setChild);
	}

	return null;
}



export { registerNotificationHandler, runNotificationHandler };
